<template>
  <div>
    <input
      :title="$t('otp.codeEnter')"
      type="text"
      inputmode="numeric"
      :placeholder="$t('otp.codeEnter')"
      :aria-label="$t('otp.code')"
      class="w-full text-body border border-solid border-formBorder rounded-small mb-0 pl-5 pr-16 py-4 placeholder-black placeholder-opacity-100"
      :class="{ 'border-danger outline-danger': otpStatus.incorrect }"
      v-model="otpCode"
      @input="formatInput"
      @keypress.enter="verifyOtp(otpCode)"
      maxlength="6"
      required
    />

    <ValidationError
      :hasError="otpStatus.incorrect"
      :errorMessage="$t('otp.codeIncorrect')"
      :errorAdvice="$t('otp.codeIncorrectAdvice')"
    />

    <p class="text-left text-sm text-gray-600 mt-2 mb-0">
      {{ $t('otp.expiresMessage', { expires: '20 minutes' }) }}
    </p>

    <BaseButton
      class="!font-medium !text-body w-full mt-6"
      :disabled="!isValidOtp"
      :loading="verifyingOtp"
      @click.native="handleVerifyOtp"
    >
      {{$t('otp.verify')}}
    </BaseButton>
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue'
import BaseButton from '@/components/library/buttons/BaseButton'
import ValidationError from '@/components/library/ValidationError.vue'

const props = defineProps({
  otpStatus: Object,
  verifyOtp: Function
})

const otpCode = ref('')
const verifyingOtp = ref(false)

const isValidOtp = computed(() => {
  return otpCode.value.length === 6
})

function formatInput (event) {
  // Only allow numbers
  otpCode.value = event.target.value.replace(/[^0-9]/g, '')
}

async function handleVerifyOtp () {
  verifyingOtp.value = true
  await props.verifyOtp(otpCode.value)
  verifyingOtp.value = false
}
</script>
